import { Navigate, Outlet } from "react-router-dom";
import AdminLayout from "@/components/admin/AdminLayout";
import { getToken } from "@/hooks/useAdminAuth";

export default function AdminGuard() {
  if (!getToken()) return <Navigate to="/ngxp-admin" replace />;
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
